import { capitalize, getDate, getDateTimeString } from '@advanza/func'
import { differenceInDays, isThisYear, isYesterday } from 'date-fns'
import { useTranslation } from 'react-i18next'

interface Props {
    date: string
    format?: string
}

const FormattedTime = ({ date: dateInput, format }: Props) => {
    const { t } = useTranslation('shared')
    const date = getDate(dateInput)
    const daysAgo = differenceInDays(new Date(), date)
    const isRecent = daysAgo < 8
    const isToday = daysAgo === 0

    const dateString = format
        ? getDateTimeString(date, format)
        : isYesterday(date)
          ? capitalize(t('yesterday'))
          : getDateTimeString(
                date,
                isToday ? 'HH:mm' : isRecent ? 'EEEE' : isThisYear(date) ? 'd MMM' : 'dd-MM-yyyy',
            )

    return <>{dateString}</>
}

export default FormattedTime
